module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 10
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 1,
      "placeholder": "多个货号之间使用英文逗号 ',' 分隔",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.params.item_bns),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bns", $$v)
      },
      expression: "params.item_bns"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 10
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 1,
      "placeholder": "多个店铺ID之间使用英文逗号 ',' 分隔",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.params.inca_ids),
      callback: function($$v) {
        _vm.$set(_vm.params, "inca_ids", $$v)
      },
      expression: "params.inca_ids"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_vm._v("\n            只看售价不同：\n            "), _c('el-switch', {
    attrs: {
      "active-value": "1",
      "inactive-value": "0",
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    on: {
      "change": function($event) {
        return _vm.acitonIsDiff()
      }
    },
    model: {
      value: (_vm.params.is_diff),
      callback: function($$v) {
        _vm.$set(_vm.params, "is_diff", $$v)
      },
      expression: "params.is_diff"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "element-loading-text": "数据加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "item_id",
      "label": "商品ID",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_bn",
      "label": "商品货号",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "店铺ID",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "店铺名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "market_price",
      "label": "商品售价",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                ￥" + _vm._s(scope.row.price / 100) + "\n              ")]
      }
    }], null, false, 4178188203)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "area_market_price",
      "label": "SKU售价",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                ￥" + _vm._s(scope.row.sku_price / 100) + "\n              ")]
      }
    }], null, false, 4034279961)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [20, 50, 100, 200, 500],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7ba35bf2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ba35bf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/skuInfo/list.vue
// module id = 2849
// module chunks = 0